import AddThumbnailContainer from "./AddThumbnailContainer";

export default AddThumbnailContainer;
